export default __webpack_public_path__ + "static/media/summary1.d1ee4a7c.svg";